import React from "react";
import LandingLayout from "../Components/landingLayout/landing.layout";

const LandingPage = () => {
	return (
		<div>
			<LandingLayout />
		</div>
	);
};

export default LandingPage;
